import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

export const initColumns = function () {
    $('[data-columns-index]').on('click', function () {
        let columns = $(this).closest('[data-columns]');
        let index = parseInt(eval($(this).attr('data-columns-index'))) - 1;
        if (columns.length) {
            let items = JSON.parse($(columns[0]).attr('data-columns'));
            let photoSwipe = new PhotoSwipe($('.pswp')[0], PhotoSwipeUI_Default, items, {index: index});
            photoSwipe.init();
        }
    });
};